import type { ContentfulCardWithImageType } from "@/types";
import type { InclusiveFundsProps } from "@/types/components/p2p-money-abroad/inclusive-funds";
import { useInView } from "@/hooks/reveal-in-view";
import { useRef, FC } from "react";
import { Image } from "../image";
import { ContentManager } from "../content-manager";
import SplitTextAnimation from "../split-text-animation";

const Card = ({ card, index }: { card: ContentfulCardWithImageType; index: number}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return <div ref={ref} className={`inclusive-funds--card-wrapper`}>
      <div className="inclusive-funds--card-wrapper--icon">
        {card.image?.file?.url && (
          <Image
            src={card.image as any}
            alt={card.image.title}
          />
        )}
      </div>
        {card.title && (
          <ContentManager
            className="inclusive-funds--card-wrapper--title"
            content={card.title}
            style={{
              transform: isInView
                ? "none"
                : `translateY(${50 * (index + 1)}px)`,
              opacity: isInView ? 1 : 0,
              transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
            }}
          />
        )}
        {card.description && (
          <ContentManager
            className="inclusive-funds--card-wrapper--description"
            content={card.description}
            style={{
              transform: isInView
                ? "none"
                : `translateY(${60 * (index + 1)}px)`,
              opacity: isInView ? 1 : 0,
              transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
            }}
          />
        )}
  </div>
};

export const InclusiveFunds: FC<InclusiveFundsProps> = ({
  header,
  cards,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="inclusive-funds">
      <div className="wrapper wrapper_lg">
        <SplitTextAnimation
          htmlElement={<h2 ref={ref} className="inclusive-funds--header">{header}</h2>}
          isInView={isInView}
        />
        <div className="inclusive-funds--cards">
          {cards.map((card: ContentfulCardWithImageType, i) =>
            <Card key={`card-${i}`} card={card} index={i} />
          )}
        </div>
      </div>
    </section>
  );
};
